export const shouldBlockSealActionForContainerVerification = ({
  containerDrop,
  isContainerNumberValidated,
}) => Boolean(containerDrop && !isContainerNumberValidated);

/**
 * Accept-only guard. Mirrors `shouldBlockAcceptForRailcarVerification`: only blocks
 * the Accept action (not Save / Request Approval). After "Proceed with Exception"
 * the left button becomes "Request Approval" (isAcceptAction=false), so this guard
 * stops reopening the container dialog on every subsequent save attempt.
 */
export const shouldBlockAcceptForContainerVerification = ({
  isAcceptAction,
  containerDrop,
  isContainerNumberValidated,
}) =>
  Boolean(isAcceptAction && containerDrop && !isContainerNumberValidated);

export const getAcceptSealDialogState = ({
  isAcceptAction,
  expectedSealNumbers = [],
  seals = [],
}) => {
  if (!isAcceptAction || expectedSealNumbers.length === 0) {
    return {
      shouldOpenSealDialog: false,
      message: "",
    };
  }

  if (expectedSealNumbers.length !== seals.length) {
    return {
      shouldOpenSealDialog: true,
      message: "Please scan all seals before accepting the shipment.",
    };
  }

  return {
    shouldOpenSealDialog: false,
    message: "",
  };
};
